import { get } from '@/utils/http'
import { SERVERS } from '@/constants/environment'

export const fetchAdviceCount = get('/customerRead/adviceCount')

export const fetchUnreadLead = get('/leadRead/unReadCount')

export const fetchInquiryCount = get('/inquiryRead/CountUnRead')

// 获取新待办数
export const fetchUnReadFeedCount = get(`/todoFeedRead/getUnReadFeedCount`)

// 获取上次刷新时间
export const getLastRefreshTime = get(`/todoFeedRead/GetLastRefreshTime`)

// 获取跟单协同未读数
export const getOmsTaskUnreadCount = get(`/productTransferRead/unhandleCount`)

// 获取未评论红点数量
export const getFacebookUnReplyCount = get(`/facebookCommentRead/getUnReplyCount`)

// 获取消息红点数量
export const getFacebookMessengerUnreadCount = get(`facebook/messengerUnreadCount`)

// 获取当前会话总未读数
export const getLiveChatUnreadCount = get(`${SERVERS.TALK_CHAT_SERVICE}/chat/getUnreadCount`)